<template>
  <div class="card-content has-text-centered">
    <br>
    <h1 class="title is-size-4">
      {{ this.$t('editionCommande.anyArticle')}}
    </h1>
    <p>
      {{ this.$t('editionCommande.addArticle')}}
    </p>
  </div>
</template>

<script>
export default {
  name: 'aucun-article',
};

</script>

<style>
</style>
